import React, { useState, useCallback } from "react";
import MockInfo, { MockInfoItem } from "../../components/SatCourse/Mockinfo";
import { useNavigate } from "react-router-dom";

const MockInfoScreen: React.FC = () => {
  const navigate = useNavigate();
  const [data] = useState<MockInfoItem[]>([
    {
      title: "Reading",
      minutes: "32:00",
      questions: "27 Questions",
      isCompleted: true,
    },
    {
      title: "Writting",
      minutes: "32:00",
      questions: "27 Questions",
      isCompleted: false,
    },
    {
      title: "Mathematics",
      minutes: "32:00",
      questions: "27 Questions",
      isCompleted: false,
    },
  ]);

  const HandleId = useCallback((title: string) => {
    if (title === "Reading" || title === "Writting") {
      navigate("/mockinstruction", { state: { title: title } });
    } else if (title === "Mathematics") {
      navigate("/mocktestmathematics", { state: { title: title } });
    }
  }, [navigate]);

  return (
    <>
      <MockInfo data={data} HandleId={HandleId} />
    </>
  );
};
export default MockInfoScreen;
